module.exports = __webpack_public_path__ + "static/UNITY-SQUARE-Two-traditional_v2-1bd9d9e08d029266827c2755d88c3357.pdf";